import { getFlatKeys } from "../Utils/DataTransform/transformData2";
import { castToNumberData } from "./transformData";
import { createMaxMinObject } from "../Utils/DataTransform/transformData2";


// Function to get unique values from a column in the raw data
const getUniqueValues = (rawData, columnField) => {
  return Array.from(new Set(rawData.map((item) => item[columnField])));
};

const calculateColumnKey = (item, measureOnTop, columnKeys, valueKeyArray) => {
  const noColumns = columnKeys.length === 0;
  if (noColumns) return valueKeyArray;

  const flatColKey = columnKeys
    .map((colKey) => (item[colKey] == null ? "null" : item[colKey])) // Check for null or undefined
    .join("|");

  return measureOnTop
    ? valueKeyArray.map((valKey) => `${valKey}|${flatColKey}`)
    : valueKeyArray.map((valKey) => `${flatColKey}|${valKey}`);
};

const calculateMaxMin = (rawData, valueKeyArray, maxMinObject) => {

  if (!rawData || !maxMinObject) return maxMinObject;
  if (!valueKeyArray || (Array.isArray(valueKeyArray) && valueKeyArray.length) === 0) {
    return maxMinObject
  }

  rawData.forEach(rawRow => {
    valueKeyArray.forEach((valKey) => {


      const cellValue = (rawRow[valKey]);

      // Update the minMax directly in the maxMinData object
      if (cellValue > maxMinObject[valKey].max) {
        maxMinObject[valKey].max = cellValue;
      }
      if (cellValue < maxMinObject[valKey].min) {
        maxMinObject[valKey].min = cellValue;
      }

    });

  });
  return maxMinObject

}



// Function to transform data for a stacked bar chart
const lineTransformData = (
  rawData,
  rawdimensionKeys,
  rawGroupbyKeys,
  valueObjectArray,
  toolTipKeys,
  returnMinMax
) => {

  if (!rawData) return null;
  let maxMinObject = returnMinMax ? createMaxMinObject(rawData[0], valueObjectArray) : {}
  // console.log(maxMinObject);

  const uniqueValueKeys = valueObjectArray.map((item) => item.responseKey);
  const uniqueTootlTipKeys = toolTipKeys.map((item) => item.responseKey);
  // uniqueValueKeys.push(...uniqueTootlTipKeys)
  if (rawdimensionKeys.length === 0) {


    //there is no column key hence we dont need to transform data
    const stringIntoNumber = castToNumberData(rawData, uniqueValueKeys)
    maxMinObject = returnMinMax ? calculateMaxMin(stringIntoNumber, uniqueValueKeys, maxMinObject) : {}
    console.log(maxMinObject);


    return { table: stringIntoNumber, lines: uniqueValueKeys, transformedTooltipKeys: uniqueTootlTipKeys, maxMinObject };
  } else {


    const columnKey = rawGroupbyKeys.map((item) => item.responseKey);
    const uniqueColumnValues = getFlatKeys(rawData, columnKey, rawGroupbyKeys);
    console.log(uniqueColumnValues);


    const dimensionKeys = rawdimensionKeys.map((item) => item.responseKey);
    const uniqueDimensionValues = getFlatKeys(rawData, dimensionKeys, rawdimensionKeys, false);
    console.log(uniqueDimensionValues, dimensionKeys);

    // Create an array to hold the combined column and measure keys
    const measureAttachedUniqueValueKeys = uniqueDimensionValues.flatMap(
      (columnValue) => {
        return uniqueValueKeys.map((measureKey) => {
          return columnValue + "|" + measureKey;
        });
      }
    );
    console.log(measureAttachedUniqueValueKeys);

    const measureAttachedUniqueToolTipKeys = uniqueDimensionValues.flatMap(
      (columnValue) => {
        return uniqueTootlTipKeys.map((measureKey) => {
          return columnValue + "|" + measureKey;
        });
      }
    );

    const cobinedMeasureAttachedKeys = [...measureAttachedUniqueToolTipKeys, ...measureAttachedUniqueValueKeys]





    const transformedTable = [];

    uniqueColumnValues.forEach((column) => {
      const modifiedRowObject = {};
      modifiedRowObject[columnKey] = column;
      cobinedMeasureAttachedKeys.forEach((key) => {
        modifiedRowObject[key] = 0;
      });
      uniqueValueKeys.forEach((valKey) => {
        const totalKey = `Total ${valKey}`;
        modifiedRowObject[totalKey] = 0
      })
      transformedTable.push(modifiedRowObject);
    });

    const columnTotalObject = {};

    measureAttachedUniqueValueKeys.forEach((measureAttachedColumnKey) => {
      columnTotalObject[measureAttachedColumnKey] = 0;
    });

    uniqueValueKeys.forEach((valKey) => {
      const totalKey = `Total ${valKey}`;
      columnTotalObject[totalKey] = 0; // Initialize row totals
    });

    console.log(transformedTable, uniqueColumnValues);


    rawData.forEach((rawRow) => {
      const rowValueKey = rawRow[columnKey[0]] === null ? "null" : rawRow[columnKey[0]]; //north,south
      console.log(rowValueKey);
      //find the corresponding object in array
      const targetObject = transformedTable.find(
        (item) => item[columnKey[0]] == rowValueKey
      );
      if (!targetObject) {
        console.log(transformedTable);
        console.log(rowValueKey);
        console.log(columnKey[0]);

        console.error(
          "there is a row which was not found in the transformed table, but was there in the raw data"
        );
      }
      const calculatedColumnKeysForValues = calculateColumnKey(
        rawRow,
        false,
        dimensionKeys,
        uniqueValueKeys

      );
      console.log(calculatedColumnKeysForValues);
      calculatedColumnKeysForValues.forEach((colKey, index) => {
        const valueKey = uniqueValueKeys[index];

        if (rawRow[valueKey] !== undefined) {
          console.log(colKey, targetObject, rawRow[valueKey])
          targetObject[colKey] = Number(rawRow[valueKey]);
          columnTotalObject[colKey] += Number(rawRow[valueKey]);
        }
      });
      const calculatedColumnKeysForTooltip = calculateColumnKey(
        rawRow,
        false,
        dimensionKeys,
        uniqueTootlTipKeys
      );
      calculatedColumnKeysForTooltip.forEach((colKey, index) => {
        const valueKey = uniqueTootlTipKeys[index];
        if (rawRow[valueKey] !== undefined) {
          targetObject[colKey] = rawRow[valueKey];
        }
      });

      uniqueValueKeys.forEach((valKey) => {
        const totalKey = `Total ${valKey}`;

        const cellValue = Number(rawRow[valKey]);
        //update the totals
        targetObject[totalKey] += cellValue;
        columnTotalObject[totalKey] += cellValue;

        if (returnMinMax) {

          // Update the minMax directly in the maxMinData object
          if (cellValue > maxMinObject[valKey].max) {
            maxMinObject[valKey].max = cellValue;
          }
          if (cellValue < maxMinObject[valKey].min) {
            maxMinObject[valKey].min = cellValue;
          }
        }
      });


    });

    console.log(maxMinObject);



    const filteredAndSortedComponents = measureAttachedUniqueValueKeys
      .filter(key => columnTotalObject.hasOwnProperty(key))  // Ensure key exists in the object
      .sort((a, b) => columnTotalObject[b] - columnTotalObject[a]);  // Sort in descending order based on value

    return { table: transformedTable, lines: filteredAndSortedComponents, transformedTooltipKeys: measureAttachedUniqueToolTipKeys, maxMinObject };
  }
};

export { lineTransformData, getUniqueValues };
